// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-tsx": () => import("/Users/devhaus/Documents/Omar/Proyectos/balvanera_gatsby/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-inicio-js": () => import("/Users/devhaus/Documents/Omar/Proyectos/balvanera_gatsby/src/pages/inicio.js" /* webpackChunkName: "component---src-pages-inicio-js" */)
}

